import {
  Button,
  Flex,
  Box,
  Avatar,
  Textarea,
  Center,
  useToast,
  Input,
} from "@chakra-ui/react";
// import { Client4 } from 'aldgpt_design/common/util/client';
import { Comment } from "@/types/content";
import {
  useGetCommentsQuery,
  useCommentContentMutation,
} from "@/services/api/endpoints/content";
import { KeyboardEvent, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { ServerError } from "@/types/errors";

type Props = {
  contentId: string;
};

const ContentComment = (props: Props) => {
  const { contentId } = props;
  const user = useSelector(selectUser);
  const toast = useToast();

  const [commentDetail, setCommentDetail] = useState("");
  const { data: CommentsList } = useGetCommentsQuery(contentId);
  const [commentContent] = useCommentContentMutation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // let inputValue = e.target.value;
    setCommentDetail(e.target.value);
  };

  const handleKeyDown = async (event:KeyboardEvent) => {
    if (event.key === "Enter") {
      const userId = user.id || "";

      let commentData: Comment = {
        content_id: contentId,
        comment_detail: commentDetail,
        user_id: userId,
        root_id: "",
      };
      console.log(commentData, "commentData>>>>>>>>>>>");

      await commentContent(commentData)
        .unwrap()
        .catch((e) => {
          toast({
            title: (e as ServerError).message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }
  };

  return (
    <>
      <Box height="100%">
        <Box mb="15px">
          <Flex gap="12px" alignItems="center">
            <Avatar w="32px" h="32px" src={`/api/v4/users/${user.id}/image`} />
            <Input
              value={commentDetail}
              onChange={handleInputChange}
              // rows={1}
              placeholder="说点什么..."
              borderColor={"#DCE0EB"}
              borderRadius="0"
              fontSize={"14px"}
              color="#8E94A9"
              style={{ minHeight: "50px" }}
              resize="vertical"
              flex={1}
              onKeyDown={handleKeyDown}
            />
            {/* <Button colorScheme='accent' size="md" isDisabled={commentDetail == ""} onClick={handlePublish} >发布</Button> */}
          </Flex>
        </Box>
        <Box
          sx={{
            height: "calc(100% - 51px)",
            overflow: "auto",
            bg: "base.800",
            boxSizing: "border-box",
            p: 4,
          }}
        >
          {CommentsList &&
            CommentsList.map((item) => {
              return (
                <Flex gap="12px" alignItems="center" key={item.id} mb={"20px"}>
                  <Avatar
                    w="32px"
                    h="32px"
                    src={`/api/v4/users/${item.user_id}/image`}
                  />
                  <Box color="#333333" fontSize={"14px"} flex={1}>{item.comment_detail}</Box>
                </Flex>
              );
            })}
          <Center p={"30px"}>评论到底啦</Center>
        </Box>
      </Box>
    </>
  );
};

export default ContentComment;
